import { exec } from "jadelet"
export default exec(["input",{"value":{"bind":"value"},"type":{"bind":"type"}},[]])